import http from './public'

export default {
    // 获取
    collectionList: (params) => {
        return http.fetchGet('collectionList', params)
    }
}